// extracted by mini-css-extract-plugin
export default {"checkboxContainer":"CheckboxInput_checkboxContainer__pK9Jn","checkboxLabel":"CheckboxInput_checkboxLabel__uiJBM"};